import { h, Fragment } from "preact";
import { useState, useEffect } from "preact/hooks";

import { Typography, Paper } from "@mui/material";

import clsx from "clsx";
import { makeStyles } from "@mui/styles";

import { Box, Button, FormControl, Stack, TextField } from "@mui/material";
import { ValidateEmail } from "../Common/helpers";
const useStyles = makeStyles((theme) => ({
	root: {
		display: "flex",
		flexWrap: "wrap",
	},
	margin: {
		margin: theme.spacing(1),
	},
	withoutLabel: {
		marginTop: theme.spacing(3),
	},
	textField: {},
}));

export default function LostPwd() {
	const classes = useStyles();
	const [values, setValues] = useState({
		email: "",
	});
	const [complete, setComplete] = useState(false);
	const handleChange = (event) => {
		setValues({ ...values, [event.target.name]: event.target.value });
	};

	const handleReset = () => {
		const requestOptions = {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(values),
		};
		fetch("/anon/69d9f8a33baf45b395519ecc0d549a69/", requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						setValues((state) => ({
							...values,
							mess: "Un mail vous sera envoyé si l'email correspond à un compte Bkeys",
						}));

						break;
					case "err":
						break;
					default:
						break;
				}
			});
	};
	useEffect(() => {
		console.log(values);
		if (ValidateEmail(values.email)) {
			setComplete(true);
		} else {
			setComplete(false);
		}
	}, [values]);
	return (
		<Box style="min-height: 500px" display="flex" justifyContent="center" alignItems="center">
			<Paper elevation={3} style="width: 400px; padding: 10px;">

				{values.mess === undefined && (
					<Stack>
						<Typography variant="h5" style="">
							Veuillez saisir votre email
						</Typography>

						<FormControl className={clsx(classes.margin, classes.textField)} variant="outlined" hiddenLabel>
							<TextField
								id="email"
								name="email"
								type="text"
								value={values.email}
								onChange={handleChange}
								fullWidth
								variant="outlined"
								margin="dense"
								size="small"
								placeholder="Email"
							/>
						</FormControl>
						<Button
							variant="contained"
							disabled={!complete}
							//  style="margin-left: 20px; padding: 10px; " 
							onClick={handleReset}
						>
							Recevoir un lien
						</Button>
					</Stack>
				)}
				{values.mess !== undefined && (
					<Stack spacing={1}>
						<Typography variant="h5" style="">
							Votre demande a bien été enregistrée.
						</Typography>
						<Typography variant="body" style="">
							{values.mess}
						</Typography>
						<Button href="/">Revenir à l'écran d'accueil</Button>
					</Stack>
				)}

			</Paper>
		</Box>
	);
}
